'use strict';

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './assets/indexResponse.module.css';
import { submitForm } from '../../actions/ContactUS';
import { Toast } from 'antd-mobile'
const print = function (value) { };
class DDS_lanhupage_5 extends Component {
  state = { realName: '', mobilePhone: '', workUnitName: '', demand: '' };
  setValue(val) { }

  onChange = (type, value) => {
    this.state[type] = value;
    if (this.state.realName && this.state.mobilePhone && this.state.workUnitName && this.state.demand) {
      this.state.canSubmit = true;
    }
    else {
      this.state.canSubmit = false;
    }
    this.setState({ ...this.state })
  }
  onSubmit = () => {
    Toast.show({
      content: '提交中...',
    })
    submitForm(this.state).then(() => {
      Toast.show({ content: '提交成功,我们会尽快跟您取得联系！' });
      this.setState({ realName: '', mobilePhone: '', workUnitName: '', demand: '' });//清空
    }).catch((e) => {
      Toast.show({ content: e.message })
    })
  }
  render() {
    return (
      <div className={`${styles.page} flex-col indexResponse_page__22n8A`}>
        <div className='arrow_up'></div>
        <span className={`${styles['text_7']} indexResponse_text_7__2rTt4  indexResponse_text_7__2-zwz`}>YingJiaInternationl</span>
        <div className={`${styles['box_5']} flex-col indexResponse_box_5__1yOvY visible`}>
          <div className={`clickable ${styles['box_6']} flex-col indexResponse_box_6__1JAFq`}>
            <div className={`${styles['section_1']} flex-col indexResponse_section_1__2vqlT`}>

              <div className={`${styles['box_23']} flex-row indexResponse_box_23__12XW3 `}>
                <div className={`${styles['box_8']} flex-col indexResponse_box_8__3hV1J `} />
              </div>
              <div className={`clickable ${styles['box_24']} indexResponse_box_24__1G4zK  flex-row justify-between`}>
                <div className={`${styles['box_25']} indexResponse_box_25__24znW  flex-col justify-between`}>
                  <div className={`${styles['box_11']} indexResponse_box_11__3XbTM flex-col`} />
                  <div className={`${styles['box_12']} indexResponse_box_12__1X_NK  flex-col`} />
                </div>

              </div>

              <div className={`${styles['box_27']} indexResponse_box_27__3089U  flex-row`}>
                <div className={`${styles['section_2']} indexResponse_section_2__2rZJM  flex-col`} />
              </div>
              <span class="indexResponse_text_3__Rp2VCd">联系我们</span>
            </div>
          </div>
        </div>
        <div className={`${styles['box_22']} flex-col indexResponse_box_22__1j5c4`}>
          <div className={`${styles['section_7']} indexResponse_section_7__DQf8t  slide-left`}>
            <div className={`${styles['box_2']} indexResponse_box_2__nHmi5  flex-col indexResponse_box_2__8d_Sh`}>

              <div className='dv_form_row_wrap'>
                <div>
                  <div className='dv_form_left_title'>对我们的产品感兴趣？</div>
                  <div className='dv_split_line'></div>
                  <div className='dv_form_small_word'>
                    可以留下您的联系方式，<br />
                    便于我们快速解决您的问题
                  </div>
                </div>
                <div className='form_submit_wrap'>
                  <form>
                    <div className='dv_input_row_wrap'>
                      <div className='dv_input_wrap'><input maxlength='10' value={this.state.realName} onChange={(e) => { this.onChange('realName', e.target.value) }} placeholder='* 您的姓名' type="text" className='inut_placeholder'></input></div>
                      <div className='dv_input_wrap'><input maxlength='15' value={this.state.mobilePhone} onChange={(e) => { this.onChange('mobilePhone', e.target.value) }} placeholder='* 您的电话' type="text" className='inut_placeholder'></input></div>
                    </div>
                    <div className='dv_input_row_single'>
                      <div className='dv_input_wrap'><input maxlength='30' value={this.state.workUnitName} onChange={(e) => { this.onChange('workUnitName', e.target.value) }} placeholder='* 您的单位' type="text" className='inut_placeholder'></input></div>
                    </div>
                    <div className='dv_input_row_single'>
                      <div className='dv_input_wrap dv_textarea_wrap'><textarea value={this.state.demand} maxlength='400' onChange={(e) => { this.onChange('demand', e.target.value) }} rows={10} placeholder='* 请简单描述您的需求' className='textarea_wrap inut_placeholder'></textarea></div>
                    </div>
                    {!this.state.canSubmit && <div className={'dv_button_sumbit_wrap  disabled button'}>提交</div>}
                    {this.state.canSubmit && <div className={'dv_button_sumbit_wrap clickable'} onClick={this.onSubmit}>提交</div>}

                  </form>
                </div>
              </div>

            </div>



          </div>
        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_5;
